import { render } from "./vehicle-two-col-layout.vue?vue&type=template&id=237827da"
import script from "./vehicle-two-col-layout.vue?vue&type=script&lang=js"
export * from "./vehicle-two-col-layout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__